// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/es5/util/colors';

import VueTextareaAutosize from 'vue-textarea-autosize';
import VueAnalytics from 'vue-analytics';

import { destroy as destroyFirebase } from '@/firebase';

import App from './App';
import router from './router';
import store from './store';

Vue.use(Vuetify, {
  theme: {
    primary: colors.teal.darken4,
  },
});
Vue.use(VueAnalytics, {
  id: 'UA-119537612-2',
  router,
});
Vue.use(VueTextareaAutosize);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});

window.addEventListener('unload', () => {
  destroyFirebase();
});



// WEBPACK FOOTER //
// ./src/main.js